import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const CALCULATION_TEHNICAL_INSPECTION_EDIT_FORM_SCHEMA = yup.object().shape({
  vehicleGroupId: yup.string().required('Molimo Vas da odaberete grupu vozila'),
  price: yup.string().required('Molimo Vas da unesete cijenu'),
});

